var rich_content_viewer_default = {
  "fontElementMap": "ztSie",
  "wrapper": "Nb24R",
  "pluginContainerMobile": "PAFDA",
  "viewer": "AtdNU",
  "android": "ZLk06",
  "rootedTraversedContent": "u05kW",
  "atomic": "h0SSB",
  "toolbar": "IA7oT",
  "block": "qCdUl"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
